<script lang="ts">
  import { onMount } from "svelte"
  import PageTemplate from "@kontextwerk/web-sdk/ui/layout/PageTemplate.svelte"
  import { spaNavigate } from "@kontextwerk/web-sdk/core"
  import { ApiError } from "../../api/public/presentation"
  import { resolvePublicShortCode } from "../../api/public/short-codes"

  const { code } = $props<{ code: string }>()

  let error = $state<string | null>(null)
  const shortCodePath = $derived(`/c/${encodeURIComponent(code)}`)
  const pageNavigation = $derived([
    {
      title: "Terminlink",
      path: shortCodePath,
      widthType: "small" as const,
      content: shortCodeContent,
    },
  ])

  const safeTargetPath = (value: string): string | null => {
    const target = value.trim()

    if (!target.startsWith("/") || target.startsWith("//")) return null

    return target
  }

  onMount(() => {
    let cancelled = false
    const openShortCode = async () => {
      try {
        const targetPath = safeTargetPath(await resolvePublicShortCode(code))

        if (!targetPath) {
          throw new ApiError(400, "Ungültiges Weiterleitungsziel.")
        }

        if (!cancelled) {
          spaNavigate(targetPath, { replace: true, noSearchParam: false })
        }
      } catch (err) {
        if (!cancelled) {
          error =
            err instanceof ApiError ? err.message : "Der Terminlink konnte nicht geöffnet werden."
        }
      }
    }

    openShortCode()

    return () => {
      cancelled = true
    }
  })
</script>

{#snippet shortCodeContent()}
  {#if error}
    <p class="short-code-error">{error}</p>
  {:else}
    <p class="short-code-loading">Der Terminlink wird geöffnet.</p>
  {/if}
{/snippet}

<PageTemplate viewKey={`short-code:${code}`} title="Termin öffnen" {pageNavigation} />

<style>
  .short-code-error,
  .short-code-loading {
    color: var(--text-80);
    margin: 0;
  }
</style>
